// Menu mobile
document.querySelector('.menu-toggle')?.addEventListener('click', function(){
  var nav = document.querySelector('.nav-links');
  var open = nav.classList.toggle('open');
  this.setAttribute('aria-expanded', open);
});

// Galerie produit
document.querySelectorAll('.thumbs button').forEach(function(btn){
  btn.addEventListener('click', function(){
    var main = document.querySelector('.gallery .main img');
    if(!main) return;
    main.src = this.dataset.full;
    main.alt = this.querySelector('img').alt;
    document.querySelectorAll('.thumbs button').forEach(function(b){ b.setAttribute('aria-current','false'); });
    this.setAttribute('aria-current','true');
  });
});

// Sélection de variante -> met à jour prix, dispo et URL
(function(){
  var form = document.getElementById('ProductForm');
  if(!form) return;
  var data = document.getElementById('VariantData');
  if(!data) return;
  var variants = JSON.parse(data.textContent);
  var selects = form.querySelectorAll('.opt select');
  var idField = form.querySelector('[name="id"]');
  var btn = form.querySelector('button[type="submit"]');
  var priceEl = document.querySelector('.prod-price .current');

  function update(){
    var chosen = Array.from(selects).map(function(s){ return s.value; });
    var match = variants.find(function(v){
      return v.options.every(function(o,i){ return o === chosen[i]; });
    });
    if(!match){ btn.disabled = true; btn.textContent = 'Unavailable'; return; }
    idField.value = match.id;
    if(priceEl) priceEl.textContent = match.price;
    btn.disabled = !match.available;
    btn.textContent = match.available ? 'Add to cart' : 'Sold out';
    if(history.replaceState){
      history.replaceState({}, '', window.location.pathname + '?variant=' + match.id);
    }
  }
  selects.forEach(function(s){ s.addEventListener('change', update); });
})();

// Tri de collection
document.getElementById('SortBy')?.addEventListener('change', function(){
  var url = new URL(window.location.href);
  url.searchParams.set('sort_by', this.value);
  url.searchParams.delete('page');
  window.location.href = url.toString();
});
